import { colors,DOCUMENT_PAPER_TYPE } from '../../Config/Constants'
import { FormContext } from '../../Models/FormContext'

const defaultState:FormContext = {
    formData: {},
    blankFormData: {},
    activeColor: colors[9],
    stepData: {},
    docId: '',
    paragraph: { paraContentId: '', paraId: '' },
    docStyle:{ letterSize: DOCUMENT_PAPER_TYPE[0].val}
}

export default defaultState
